import { getServiceUrl } from './api.config';
import { ApiClientOptions } from './types/api';
import ApiClient from './utils/ApiClient';
import qs from './utils/query';
import { isPositiveInteger } from './utils/validators';

export default class EdaApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('eda'), options);
  }

  // =============================================================================
  // RabbitMQ
  // =============================================================================

  public RmqListErrorQueues() {
    const query = '/eda/rmq/v1/errors';
    const parameters = `?alk=1`;
    return this.get(query, parameters);
  }

  public RmqListBindings(routing_key?: string) {
    const query = '/eda/rmq/v1/topology/bindings';
    const params: any = {};
    if (routing_key) {
      params.routing_key = routing_key;
    }
    return this.get(query, qs.stringify(params, true));
  }

  public RmqErrorDetail(queueName: string, limit: number) {
    const query = `/eda/rmq/v1/error/${queueName}`;
    const params: any = {};
    if (isPositiveInteger(limit)) {
      params.limit = limit;
    }
    return this.get(query, qs.stringify(params, true));
  }

  public RmqErrorAction(queueName: string, action: string, limit: number) {
    const query = `/eda/rmq/v1/error/${queueName}/${action}`;
    const params: any = {};
    if (isPositiveInteger(limit)) {
      params.limit = limit;
    }
    return this.get(query, qs.stringify(params, true));
  }

  public RmqErrorPurge(queueName: string) {
    const query = `/eda/rmq/v1/error/${queueName}/purge`;
    const parameters = `?alk=1`;
    return this.get(query, parameters);
  }
}
